import React from 'react';
import { ButtonV2 } from 'ui/ButtonV2';
import InfoOutlineIcon from '@mui/icons-material/InfoOutline';
import { useTranslation } from 'react-i18next';
import { styled } from '@mui/material';
import { blendColors, manipulateColor } from 'lib/helpers';
import { EGAEventName, useGAHelpers } from 'lib/useGAHelpers';

const StyledButton = styled(ButtonV2, { shouldForwardProp: prop => prop !== 'desktop' })<{
    desktop: boolean;
}>(({ theme, desktop }) => ({
    fontFamily: `SecondaryFont, ${theme.typography.fontFamily}`,
    marginTop: 0,
    justifyContent: 'space-between',
    borderWidth: desktop ? 0 : 2,
    borderColor: desktop ? theme.palette.background.default : theme.palette.primary.main,
    fontSize: '1rem',
    backgroundColor: desktop
        ? blendColors(theme.palette.primary.main, theme.palette.primary.contrastText, 0.9)
        : undefined,
    color: desktop ? manipulateColor(theme.palette.primary.main, 0.8) : undefined
}));

interface MenuAllergenButtonProps {
    link: string;
    desktop?: boolean;
}

export const MenuAllergenButton: React.FC<MenuAllergenButtonProps> = ({ link, desktop = false }) => {
    const { t } = useTranslation();
    const { logUserEvent } = useGAHelpers();
    const handleCLick = React.useCallback(() => {
        logUserEvent(EGAEventName.MenuAllergensButtonTapped);
    }, [logUserEvent]);
    return (
        <a href={link} target="_blank" rel="noopener noreferrer" onClick={handleCLick}>
            <StyledButton desktop={desktop} variant="outlined" endIcon={<InfoOutlineIcon />}>
                {t('MENU_ALLERGENS_BUTTON')}
            </StyledButton>
        </a>
    );
};
